import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import PhotoStyles from './photoStyles';

const Photo = () => {};

const PhotoList = props => {
  return <PhotoStyles.ListStyles mt={props.mt}>{props.children}</PhotoStyles.ListStyles>;
};

PhotoList.propTypes = {
  mt: PropTypes.number,
  children: PropTypes.node.isRequired,
};

PhotoList.defaultProps = {
  mt: undefined,
};

const PhotoImageWrapper = props => {
  return (
    <PhotoStyles.ImageWrapperStyles {...props}>{props.children}</PhotoStyles.ImageWrapperStyles>
  );
};

PhotoImageWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

const PhotoItem = forwardRef((props, ref) => {
  return (
    <PhotoStyles.ItemStyles ref={ref} {...props}>
      {props.children}
    </PhotoStyles.ItemStyles>
  );
});

PhotoItem.propTypes = {
  type: PropTypes.string,
  selected: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

const PhotoButtons = props => {
  return <PhotoStyles.ButtonsStyles>{props.children}</PhotoStyles.ButtonsStyles>;
};

PhotoButtons.propTypes = {
  children: PropTypes.node.isRequired,
};

PhotoItem.defaultProps = {
  type: 'photo',
};

Photo.List = PhotoList;
Photo.ImageWrapper = PhotoImageWrapper;
Photo.Item = PhotoItem;
Photo.Buttons = PhotoButtons;

export default Photo;
